<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright1"><a id="page_4"></a>This is a work of fiction. All the characters and events portrayed in<br/>this novel are either fictitious or are used fictitiously.</p>
<p class="copyright">MURCHESTON: THE WOLF’S TALE</p>
<p class="copyright">Copyright © 2000 by David Holland</p>
<p class="copyright">All rights reserved, including the right to reproduce this book, or<br/>portions thereof, in any form.</p>
<p class="copyright">This book is printed on acid-free paper.</p>
<p class="copyright">A Forge Book<br/>Published by Tom Doherty Associates, LLC<br/>175 Fifth Avenue<br/>New York, NY 10010</p>
<p class="copyright"><span class="weblink"><a class="nounder" href="http://www.tor.com" target="_blank">www.tor.com</a></span></p>
<p class="copyright">Forge<sup>®</sup> is a registered trademark of Tom Doherty Associates, LLC.</p>
<p class="copyright">Design by Lisa Pifher</p>
<p class="copyright">Library of Congress Cataloging-in-Publication Data</p>
<p class="copyright">Holland, David.</p>
<p class="copyright2">Murcheston : the wolf’s tale / David Holland.</p>
<p class="copyright2">    p.     cm.</p>
<p class="copyright2">“A Tom Doherty Associates book.”</p>
<p class="copyright2">ISBN 0-312-87213-5 ISBN 978-0-312-87213-7</p>
<p class="copyright2">1. Werewolves—England—London—Fiction. 2. London<br/>(England)—Fiction. I. Title.</p>
<p class="copyright3">PS3558.O3482 M87 2000<br/>813’.54—dc21</p>
<p class="copyrightr">99-055052</p>
<p class="copyright">First Edition: February 2000</p>
<p class="copyright">Printed in the United States of America</p>
<p class="copyright">0   9   8   7   6   5   4   3   2   1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?6f123211